import { ValidationResult, ValidatorResult } from '../index';
import _last from 'lodash.last';
import { LogoShape } from '@/web-components/import-wizard/typings/pintura';

export const gradientFileValidator =
  (
    shape: LogoShape,
    printPositionId: string,
    isTraditionalTechnique: boolean
  ) =>
  ({ payload, validationResult }: ValidatorResult): ValidatorResult => {
    const validatorName = 'gradientFileValidator';
    const { fileName, hasGradient, id, personalizationArtworkId } = shape;

    Object.assign(payload, { id, personalizationArtworkId, fileName });

    return {
      payload,
      validationResult: validationResult.concat([
        {
          printPositionId: printPositionId,
          validatorName: validatorName,
          validatorColor:
            hasGradient && isTraditionalTechnique ? 'Red' : 'Green',
          message: `File ${fileName} has gradient colors`,
        },
      ]) as ValidationResult,
    };
  };
